"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconStarHalfFilled = function IconStarHalfFilled(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.5 3.26929C10.8197 3.26929 11.1117 3.45079 11.2532 3.73748L13.1344 7.54864L17.3415 8.16356C17.6578 8.20979 17.9204 8.43156 18.019 8.73565C18.1176 9.03973 18.0351 9.37343 17.8061 9.59647L14.7626 12.5608L15.4808 16.7487C15.5349 17.0639 15.4053 17.3824 15.1466 17.5703C14.8879 17.7583 14.545 17.783 14.2619 17.6342L10.5 15.6558L6.73798 17.6342C6.45498 17.783 6.11201 17.7583 5.85331 17.5703C5.59461 17.3824 5.46504 17.0639 5.51909 16.7487L6.23737 12.5608L3.19387 9.59647C2.96487 9.37343 2.88232 9.03973 2.98092 8.73565C3.07952 8.43156 3.34217 8.20979 3.65848 8.16356L7.86551 7.54864L9.74673 3.73748C9.88825 3.45079 10.1802 3.26929 10.5 3.26929ZM10.5 6.00706L9.17672 8.68781C9.05447 8.93548 8.81827 9.10723 8.54497 9.14718L5.58463 9.57988L7.72606 11.6656C7.92419 11.8586 8.01463 12.1368 7.96788 12.4094L7.46268 15.3549L10.109 13.9633C10.3537 13.8346 10.6462 13.8346 10.8909 13.9633L13.5373 15.3549L13.0321 12.4094C12.9853 12.1368 13.0757 11.8586 13.2739 11.6656L15.4153 9.57988L12.455 9.14718C12.1817 9.10723 11.9455 8.93548 11.8232 8.68781L10.5 6.00706Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.5 14V5.5V5L8.5 8.5L5 9L7.5 11.5V15.5L10.5 14Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.12"
  }));
};

IconStarHalfFilled.defaultProps = {
  color: 'black'
};
IconStarHalfFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconStarHalfFilled;
exports.default = _default;